import {CARD} from "~/constants/api/payment/payment";

export async function deleteCard(id:string) {
    return await useApi(`${CARD.replace(':id',id)}`,'DELETE',{})
}